const Color = { GREY: '#BCBCBC', YELLOW: '#FC8F00' }

const RatingVoc = {
  RELEVANCE: 'relevance',
}

const InitRating = {
  [RatingVoc.RELEVANCE]: 0,
}

const BeforeLoadRaiting = {
  [RatingVoc.RELEVANCE]: -1,
}

const starPoints = [1, 2, 3, 4, 5]

export { Color, RatingVoc, InitRating, BeforeLoadRaiting, starPoints }
